export default "__VITE_ASSET__bfad014b__"